import type { StyleSpecification } from "@vietmap/vietmap-gl-js/dist/vietmap-gl";
import { cn } from "@/lib/utils";
import MapPreviewThumb from "../MapPreviewThumb";

/** Nền giả theo theme khi chưa có API key / consumer để render map thật. */
const PLACEHOLDER: Record<number, string> = {
  0: "bg-[linear-gradient(135deg,#f3e9d2_0%,#e1d4b2_35%,#a7c5eb_100%)]",
  1: "bg-[linear-gradient(135deg,#ffffff_0%,#ecf2f9_50%,#c8d8ec_100%)]",
  2: "bg-[linear-gradient(135deg,#0f172a_0%,#1e293b_50%,#475569_100%)]",
  3: "bg-[linear-gradient(135deg,#4a3a26_0%,#5a6843_40%,#2f4d3a_75%,#4f7136_100%)]",
};

type MapThumbProps = {
  /** URL style.json đã gắn apikey; rỗng → chỉ hiện nền giả. */
  styleUrl: string
  themeMode: number
  className?: string
  /** Map view; default = all of Vietnam. */
  center?: [number, number]
  zoom?: number
  transformStyle?: (style: StyleSpecification) => StyleSpecification
};

export function MapThumb({ styleUrl, themeMode, className, center, zoom, transformStyle }: MapThumbProps) {
  const classes = cn(
    "bg-muted relative overflow-hidden bg-cover bg-center",
    PLACEHOLDER[themeMode] ?? PLACEHOLDER[0],
    className
  );
  if (!styleUrl) return <div className={classes} />;
  return <MapPreviewThumb lazy styleUrl={styleUrl} className={classes} center={center} zoom={zoom} transformStyle={transformStyle} />;
}
